<template>
  <Modal v-model="showDetail" :title="personnelId?'编辑':'新增'" :mask-closable="false" :closable='false'>
    <Form :model="form" ref="form" :rules="rules" :label-width="80">
      <FormItem label="姓名" prop="name">
        <Input v-model="form.name" placeholder="请输入"></Input>
      </FormItem>
      <FormItem label="工号" prop="number">
        <Input v-model="form.number" placeholder="请输入"></Input>
      </FormItem>
      <FormItem label="事业部" prop="causeDepartment">
        <Input v-model="form.causeDepartment" placeholder="请输入"></Input>
      </FormItem>
      <FormItem label="部门" prop="department">
        <Input v-model="form.department" placeholder="请输入"></Input>
      </FormItem>
	  <FormItem label="岗位" prop="post">
	    <Select v-model="form.post">
	      <Option :value="item.value" v-for="(item,index) in postList" :key="index">{{item.name}}</Option>
	    </Select>
	  </FormItem>
	  <FormItem label="入职时间" prop="joinedCompanyDate">
	      <DatePicker type="date" v-model="form.joinedCompanyDate" placeholder="请选择" style="width: 100%" />
	  </FormItem>
	  <FormItem label="在职状态" prop="workStatus">
	    <Select v-model="form.workStatus">
	      <Option :value="item.value" v-for="(item,index) in workStatusList" :key="index">{{item.name}}</Option>
	    </Select>
	  </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn">保存</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'UpdatePersonnel',
  props: {
    showDetail: Boolean, //弹窗 窗口显示
    personnelId: Number,
  },
  data() {
    return {
      form: {
        name: '',
        number: '',
        causeDepartment: '',
        department: '',
        post: null,
        joinedCompanyDate: null,
        workStatus: null,
        id: this.personnelId,
      },
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        number: [
          { required: true, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        causeDepartment: [{ required: false, message: '请输入', trigger: 'blur,change', type: 'string' }],
        department: [{ required: false, message: '请输入', trigger: 'blur,change', type: 'string' }],
        post: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }],
		joinedCompanyDate: [{ required: false, message: '请选择', trigger: 'blur,change', type: 'date' }],
        workStatus: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }]
      },
      postList: [], //岗位list
      workStatusList: [], //在职状态list
	  
	  spinShow: false,
    }
  },
  mounted() {
	  this.getUserSelectList();
	  console.log(this.personnelId+"111")
    if (this.personnelId) {
	  this.spinShow = true
      this.getDetail()
    }
  },
  methods: {
	  //获取下拉框
	  async getUserSelectList() {
	    const { data } = await this.$Ajax.get(
	      '/api/services/app/User/GetPersonnelInitData'
	    )
	    this.postList = data.result.postList
	    this.workStatusList = data.result.workStatusList
	  },
    //获取人员详情
    async getDetail() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/User/GetUserDetail?id=${this.personnelId}`
      )
      this.form = data.result
      this.spinShow = false
    },
    // 关闭弹窗
    close(refresh) {
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    // 提交
    submit() {
      let _this = this
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.spinShow = true
          let url = ''
          let method = 'post'
		  url = '/api/services/app/User/UpdateUser_Attendance'
          let { data } = await this.$Ajax[method](url, this.form)
          if (data.success) {
            this.$Message.success({
              content: '编辑成功',
            })
            _this.close(true)
          }
          this.spinShow = false
        }
      })
    },
  },
}
</script>